import { render, staticRenderFns } from "./CouponView.vue?vue&type=template&id=20f31708&scoped=true&"
import script from "./CouponView.vue?vue&type=script&lang=js&"
export * from "./CouponView.vue?vue&type=script&lang=js&"
import style0 from "./CouponView.vue?vue&type=style&index=0&id=20f31708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f31708",
  null
  
)

export default component.exports